import './t18n.scss';

import { Logger } from './logger';

let instance = null;

class _T18n {
  constructor() {
    // implement singleton design pattern
    if (instance) {
      return instance;
    }
    instance = this;

    this._library = {};
    this._defaultLangId = 'en';
    this._currentLangId = this._defaultLangId;
    this._currentDictId = undefined;
  }

  setCurrentLangId(langId) {
    this._currentLangId = langId;
  }

  setCurrentDictId(dictId) {
    this._currentDictId = dictId;
  }

  /**
   * Fetch from the page's markup the dictionary having the given [data-t18n-dict-id="..."] attribute,
   * and add the dictionary to the T18n library (list of dictionaries).
   */
  addDictionaryFromMarkup(dictId) {
    const $dict = $(`[data-t18n-dict-id="${dictId}"]`);
    const dictionary = {};
    $dict.find('[data-t18n-lang]').each(function () {
      const $lang = $(this);
      const langId = $lang.data('t18n-lang');
      const language = {};
      $lang.find('[data-t18n-item]').each(function () {
        const $item = $(this);
        const itemId = $item.data('t18n-item');
        const itemValue = $item.html();
        language[itemId] = itemValue;
      });
      dictionary[langId] = language;
    });
    this._library[dictId] = dictionary;
  }

  getTranslation(itemId, langIdOpt, dictIdOpt) {
    let retVal;
    const langId = langIdOpt || this._currentLangId;
    const dictId = dictIdOpt || this._currentDictId;

    const dictionary = this._library[dictId];

    if (dictionary) {
      const language = dictionary[langId];
      if (language) {
        const item = language[itemId];
        if (item) {
          retVal = item;
        } else {
          Logger.log(`T18n.getTranslation() could not find the item "${itemId}" for the "${langId}" language in the "${dictId}" dictionary.`);
        }
      } else {
        Logger.log(`T18n.getTranslation() could not find the "${langId}" language in the "${dictId}" dictionary.`);
      }

      // falling back on the default language
      if (!retVal && langId !== this._defaultLangId) {
        Logger.log(`Falling back on default language "${this._defaultLangId}".`);
        retVal = this.getTranslation(itemId, this._defaultLangId, dictId);
      }
    } else {
      Logger.log(`T18n.getTranslation() could not find the "${dictId}" dictionary.`);
    }
    return retVal;
  }

  _(itemId, langIdOpt, dictIdOpt) {
    return this.getTranslation(itemId, langIdOpt, dictIdOpt);
  }
}

export const T18n = new _T18n();
